<script>
export default {
	props: ['data'],
}
</script>

<template>
	<CardLayout @cardClick="$emit('optionSelected')" clickable>
		<CashCardContent :message="data.message" />
	</CardLayout>
</template>
